import * as React from 'react';
import { Dispatch } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { StoreState } from '../../../../../reducers';
import Select from '../../Select';
import { Option, OptionLabel, OptionColorsList, Color } from './styles';
import { ThemesState } from '../../../../../containers/Editor/reducer';
import { selectTheme } from '../../../../../containers/Editor/actions';

interface SelectThemeProps {
	themes: ThemesState;
	themeId: string;
	dispatch: Dispatch<StoreState>;
}

const SelectTheme = ({ themes, themeId, dispatch }: SelectThemeProps) => {
	const options = Object.values(themes).map(({ id, name, colors }) => ({
		values: [id],
		label: name,
		displayedLabel: (
			<Option>
				<OptionLabel>{name}</OptionLabel>
				<OptionColorsList>
					{colors.map((color, index) => <Color key={index} color={color} />)}
				</OptionColorsList>
			</Option>
		),
	}));

	const handleChange = (value: string) => {
		dispatch(selectTheme(value, true));
	};

	return (
		<Select
			label={`${I18n.t('messages.theme')}:`}
			value={themeId}
			options={options}
			optionsLabel="messages.your_themes"
			onChange={handleChange}
		/>
	);
};

export default SelectTheme;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/SelectTheme/index.tsx